import { ReactNode } from 'react';
import { Flex, Radio, Text } from '@mantine/core';
import styled from 'styled-components';

interface Props {
	label: string;
	description: ReactNode;
	checked: boolean;
	disabled?: boolean;
	onSelect: () => void;
	dataTestId?: string;
}

export const RadioOptionCard = ({
	label,
	description,
	checked,
	disabled,
	onSelect,
	dataTestId,
}: Props) => (
	<RadioCard
		$selected={checked}
		$disabled={!!disabled}
		onClick={disabled ? undefined : onSelect}
		data-testid={dataTestId}
	>
		<Radio
			checked={checked}
			onChange={onSelect}
			disabled={disabled}
			label={
				<Flex direction="column" gap="0.25rem">
					<Text variant="p-md" fw={600} c="dark.8">
						{label}
					</Text>
					<Text variant="p-md" c="dark.6">
						{description}
					</Text>
				</Flex>
			}
		/>
	</RadioCard>
);

const RadioCard = styled.div<{ $selected: boolean; $disabled: boolean }>`
	padding: 0.75rem 1rem;
	border-radius: 0.5rem;
	border: 1px solid
		${({ theme, $selected }) => ($selected ? theme.v3.colors.blue[6] : theme.v3.colors.gray[2])};
	cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`;
